import { companyUnitsSelector, CompanyUnitSelectorProps, useGetAllCompanyUnitsQuery } from "@ots-frontend/ots-data";
import { useMemo } from "react";
import { BaseCompanyUnitSelect, BaseCompanyUnitSelectProps } from "./BaseCompanyUnitSelect";

export type CompanyUnitSelectProps = Omit<BaseCompanyUnitSelectProps, "entities" | "loading"> & {
  selector?: CompanyUnitSelectorProps
}

export const CompanyUnitSelect = (props: CompanyUnitSelectProps) => {
  const { selector, ...rest } = props;

  const selectCompanyUnits = useMemo(() => {
    return companyUnitsSelector();
  }, []);

  const { companyUnits, isLoading } = useGetAllCompanyUnitsQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      companyUnits: selectCompanyUnits(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseCompanyUnitSelect entities={companyUnits} loading={isLoading} {...rest} />;
};
